import axios from 'axios'
import {FileInputValue} from '../../../../components/inputs/FileInput/FileInputValue'
import {
  CustomerModel,
  CustomerModelCreateFormData,
  CustomerServicesModel,
} from '../../../../models/CustomerModel'
import {FileModel} from '../../../../models/FileModel'
import {FilterModel} from '../../../../models/FilterModel'
import {GlobalSearchModel} from '../../../../models/GlobalSearchModel'
import {GuestModel} from '../../../../models/GuestModel'
import {ISOCountryModel} from '../../../../models/ISOCountryModel'
import {
  CustomerCategoryModel,
  CustomerCategoryModelCreateParams,
} from '../../../../models/svc/CustomerCategoryModel'
import {TemplateEmailTypeModel} from '../../../../models/svc/TemplateEmailTypeModel'
import {TemplateFieldModel} from '../../../../models/svc/TemplateFieldModel'
import {
  TemplateModel,
  TemplateModelCreateParams,
  TemplateModelType,
} from '../../../../models/svc/TemplateModel'

import {VoucherModel, VoucherModelCreateParams} from '../../../../models/svc/VoucherModel'

const CRUD_CUSTOMER = '/customer'
const MASTER_SEARCH_CUSTOMER = '/customer/list'

export const GetCustomers = (filter?: FilterModel) =>
  axios.post<GlobalSearchModel<CustomerModel>>(MASTER_SEARCH_CUSTOMER, filter)
export const GetSpeakers = (filter?: FilterModel) =>
  axios.post<GlobalSearchModel<CustomerModel>>(MASTER_SEARCH_CUSTOMER, filter)
export const GetCustomerByCode = (code: string) =>
  axios.get<CustomerModel>(`${CRUD_CUSTOMER}/${code}`)
export const PostCustomer = (data: CustomerModelCreateFormData) =>
  axios.post(CRUD_CUSTOMER, data.getFormData(), {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

export const GetCustomerPaByCode = (code: string) =>
  axios.get(`/personal-assistant${CRUD_CUSTOMER}/${code}`)

export const PostCustomerPa = (payload: FormData) => axios.post(`/personal-assistant`, payload)

export const PutCustomerPa = (customerCode: string, params: FormData) =>
  axios.put(`/personal-assistant/${customerCode}`, params)

export const GetCustomerServicesByCustomerCode = (customerCode: string, payload: any) =>
  axios.post(`/customer-service${CRUD_CUSTOMER}/${customerCode}`, payload)
export const GetCustomerServices = (filter?: FilterModel) =>
  axios.post<GlobalSearchModel<CustomerServicesModel>>(`customer-service/list`, filter)
export const GetCustomerServiceByCode = (code: string) => axios.get(`/customer-service/${code}`)
export const PutCustomerService = (customerCode: string, payload: FormData) =>
  axios.put(`/customer-service/${customerCode}`, payload)
export const DeleteCustomerService = (code: string[] | string) =>
  axios.delete(`/customer-service`, {data: {codes: Array.isArray(code) ? code : [code]}})

export const PostCustomerFiles = async (data: FileInputValue[], customerCode: string) => {
  const formData = new FormData()
  data.forEach((file) => {
    const document = file.getFile()
    if (document) {
      formData.append('documents', document)
    }
  })
  await axios.put(`${CRUD_CUSTOMER}/documents/upload/${customerCode}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const DeleteCustomerFiles = async (fileCodes: string[], customerCode: string) => {
  await axios.delete(`${CRUD_CUSTOMER}/documents/${customerCode}`, {data: {codes: fileCodes}})
}

export const PutCustomer = (data: CustomerModelCreateFormData, customerCode: string) =>
  axios.put(`${CRUD_CUSTOMER}/${customerCode}`, data.getFormData(), {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
export const DeleteCustomer = (customerCode: string[] | string) =>
  axios.delete(CRUD_CUSTOMER, {
    data: {codes: Array.isArray(customerCode) ? customerCode : [customerCode]},
  })
export const GetISOCountries = () => axios.get<ISOCountryModel[]>(`${CRUD_CUSTOMER}/country`)
export const ActivateCustomers = (customerCodes: string[]) =>
  axios.post(`${CRUD_CUSTOMER}/activate`, {codes: customerCodes})
export const SendRegistrationLink = (customerCodes: string[], eventCode: string) =>
  axios.post('/customer/send-registration', {
    codes: customerCodes,
    eventCode,
  })
export const GetRegistrationLink = (customerCode: string, eventCode: string) =>
  axios.post<{url: string}>(`/customer/registration/${customerCode}`, {
    eventCode,
    customerCode,
  })
export const SearchVoucherTemplates = (filter?: FilterModel) =>
  axios.post<GlobalSearchModel<VoucherModel>>(`/voucher/list/template`, filter)
export const SearchVouchers = (filter?: FilterModel) =>
  axios.post<GlobalSearchModel<VoucherModel>>(`/voucher/list`, filter)
export const CreateVoucher = (params: VoucherModelCreateParams) => axios.post(`/voucher`, params)

export const GetVoucherTopupHistory = (eventCode: string) =>
  axios.post<Blob>(
    `/voucher/report`,
    {eventCode},
    {
      responseType: 'blob',
    }
  )
export const GetVoucherByCode = (voucherCode: string) => axios.get(`/voucher/${voucherCode}`)
export const UpdateVoucher = (voucherCode: string, params: VoucherModelCreateParams) =>
  axios.put(`/voucher/${voucherCode}`, params)
export const DeleteVouchers = (voucherCodes: string[]) =>
  axios.delete(`/voucher`, {
    data: {
      codes: voucherCodes,
    },
  })
export const DisableVouchers = (voucherCodes: string[]) =>
  axios.post(`/voucher/disable`, {
    codes: voucherCodes,
  })
export const ActivateVoucher = (voucherCode: string, customerCode: string) =>
  axios.post(`/voucher/activate`, {voucherCode, customerCode})
export const PrintVoucher = (voucherCodes: string[]) =>
  axios.post(`/template/print/vouchers`, {codes: voucherCodes}, {responseType: 'blob'})
export const TopupVoucher = (voucherCode: string, amount: number) =>
  axios.post(`/voucher/top-up/${voucherCode}`, {amount})

export const CreateImport = (mapping: string[], csv: File, hasHeaders: boolean = true) => {
  const formData = new FormData()
  formData.append('file', csv)
  mapping.forEach((map, index) => {
    formData.append(`map[${index}]`, map)
  })
  formData.append('hasHeaders', String(hasHeaders))
  return axios.post(`/import`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const MapCustomer = () => axios.get(`/import/map-customer`)
export const MapCustomerAddress = () => axios.get(`/import/map-customer-address`)
export const MapProduct = (eventCode: string) =>
  axios.post(`/import/map-product`, {event: eventCode})
export const MapBookingToEvent = (eventCode: string) =>
  axios.post(`/import/map-booking`, {event: eventCode})
export const SearchImports = (filter: FilterModel) => axios.post(`/import/list`, filter)
export const ResetImports = () => axios.delete(`/import`)

export const GetCustomerCategoryList = (filter?: FilterModel) =>
  axios.post<GlobalSearchModel<CustomerCategoryModel>>('/customer-category/list', filter)
export const GetCustomerCategoryByCode = (code: string) =>
  axios.get<CustomerCategoryModel>(`/customer-category/${code}`)
export const CreateCustomerCategory = (payload: CustomerCategoryModelCreateParams) =>
  axios.post(`/customer-category`, payload)
export const UpdateCustomerCategory = (code: string, payload: CustomerCategoryModelCreateParams) =>
  axios.put(`/customer-category/${code}`, payload)
export const DeleteCustomerCategories = (codes: string[]) =>
  axios.delete(`/customer-category`, {
    data: {
      codes,
    },
  })
export const SetCategoryAsDefault = (code: string) =>
  axios.post(`/customer-category/default/${code}`)
export const UnsetCategoryAsDefault = (code: string) =>
  axios.post(`/customer-category/remove-default/${code}`)
export const GetCustomerCategoryTree = () =>
  axios.get<CustomerCategoryModel[]>(`/customer-category/tree`)

export const CreateEventGuest = (
  email: string,
  name: string,
  eventCode: string,
  productCode?: string,
  customerCode?: string
) =>
  axios.post(`/guest`, {
    email,
    name,
    eventCode,
    productCode,
    customerCode,
  })
export const AssignGuestCategory = (eventCode: string, productCode: string, guestCodes: string[]) =>
  axios.post(`/guest/assign`, {
    eventCode,
    productCode,
    codes: guestCodes,
  })
export const ReassignGuestCategory = (
  eventCode: string,
  productCode: string,
  customerCodes: string[],
  reason: string
) =>
  axios.post(`/guest/re-assign`, {
    eventCode,
    productCode,
    codes: customerCodes,
    reason,
  })
export const ConfirmGuests = (eventCode: string, guestCodes: string[]) =>
  axios.post(`/guest/confirm`, {
    eventCode,
    codes: guestCodes,
  })
export const CancelGuests = (eventCode: string, reason: string, guestCodes: string[]) =>
  axios.post(`/guest/cancel`, {
    eventCode,
    reason,
    codes: guestCodes,
  })
export const SendGuestRegistration = (eventCode: string, guestCodes: string[]) =>
  axios.post(`/guest/send-registration`, {
    eventCode,
    codes: guestCodes,
  })
export const GetGuestRegistrationLink = (guestCode: string) =>
  axios.get<{url: string}>(`/guest/registration-link/${guestCode}`)
export const SendGuestRsvp = (eventCode: string, guestCodes: string[]) =>
  axios.post(`/guest/send-rsvp`, {
    eventCode,
    codes: guestCodes,
  })
export const AssignGuestSeat = (
  guestCode: string,
  locationCode: string,
  seatRow: string,
  seatNo: string | number
) =>
  axios.put(`/guest/assign-seat/${guestCode}`, {
    locationCode,
    seatRow,
    seatNo: String(seatNo),
  })
export const GetGuestList = (filters?: FilterModel) =>
  axios.post<GlobalSearchModel<GuestModel>>(`/guest/list`, filters)
export const GetGuestByCode = (code: string) => axios.get<GuestModel>(`/guest/${code}`)
export const PrintGuestBadges = (guestCodes: string[]) =>
  axios.post<Blob>(
    `/template/print/guests`,
    {
      codes: guestCodes,
    },
    {
      responseType: 'blob',
    }
  )
export const ReprintGuestBadges = (guestCodes: string[], reason: string) =>
  axios.post<Blob>(
    `/template/reprint/guests`,
    {
      codes: guestCodes,
      reason,
    },
    {
      responseType: 'blob',
    }
  )
export const ActivateGuestCard = (rfid: string, guestCode: string) =>
  axios.post(`/guest/activate-card`, {
    code: guestCode,
    rfid,
  })

export const GetTemplateEmailTypes = () =>
  axios.get<TemplateEmailTypeModel[]>(`/template/email-types`)
export const GetFieldsByEmailTypeCode = (type: TemplateModelType, emailTypeCode?: string) =>
  axios.post<TemplateFieldModel[]>(`/template/fields`, {type, emailTypeCode})
export const GetTemplateByCode = (code: string) => axios.get<TemplateModel>(`/template/${code}`)
export const SearchTemplates = (filters?: FilterModel) =>
  axios.post<GlobalSearchModel<TemplateModel>>(`/template/list`, filters)
export const CreateTemplate = (data: TemplateModelCreateParams) =>
  axios.post<TemplateModel>(`/template`, data)
export const UpdateTemplate = (code: string, data: TemplateModelCreateParams) =>
  axios.put<TemplateModel>(`/template/${code}`, data)
export const DeleteTemplates = (codes: string[]) =>
  axios.delete<TemplateModel>(`/template`, {
    data: {
      codes,
    },
  })

export const SearchTemplateFonts = (filters?: FilterModel) =>
  axios.post<GlobalSearchModel<FileModel>>(`/font-file/list`, filters)
export const UploadTemplateFontFile = (fontFile: Blob) => {
  const formData = new FormData()
  formData.append('fontFile', fontFile)
  return axios.post<FileModel[]>(`/font-file/upload`, formData)
}
export const DeleteTemplateFonts = (codes: string[]) => axios.delete(`/font-file`, {data: {codes}})

export const SearchTemplateImages = (filters?: FilterModel) =>
  axios.post<GlobalSearchModel<FileModel>>(`/template-image/list`, filters)
export const UploadTemplateImageFile = (image: Blob) => {
  const formData = new FormData()
  formData.append('templateImage', image)
  return axios.post<FileModel[]>(`/template-image/upload`, formData)
}
export const DeleteTemplateImages = (codes: string[]) =>
  axios.delete(`/template-image`, {data: {codes}})
